/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React, { useEffect, useState } from 'react';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
import { updatestatus, getAlltemplate, deletetemplate, copytemplate, submitapproval } from 'src/services/templateService';
import { Autocomplete, Grid, IconButton, Menu, MenuItem, TextField, TextareaAutosize } from '@mui/material';
import type { TableColumn } from 'react-data-table-component';
import MUIModal from '../MUIModal/MUIModal';
import AddTemplateForm from './AddTemplateForm';
import GradientButton from '../MUICustomButton/GradientButton';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { MoreVerticalSolidRounded } from '@hugeicons-pro/core-solid-rounded';
//@ts-ignore
import { MultiplicationSignStrokeStandard, Comment02Icon  } from '@hugeicons-pro/core-stroke-standard';
//@ts-ignore
import { ArrowDown01Icon } from '@hugeicons-pro/core-stroke-standard';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import { ARE_YOU_SURE, DELETE_TEMPLATE, TEMPLATE_IN_USE_MESSAGE, ACTIVATE_TEMPLATE_SUCCESS_MESSAGE, COPY_TEMPLATE_SUCCESS_MESSAGE, DEACTIVATE_TEMPLATE_SUCCESS_MESSAGE, DELETE_TEMPLATE_SUCCESS_MESSAGE, COPY_TEMPLATE, TEMPLATE_DELETE_INVALID, LABEL_BTN_CANCEL } from 'src/constants/constant';
import OutlineButton from '../MUICustomButton/OutlineButton';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';
import type { appConfigs, RootState } from '../types/types';
import { FormControl } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom'
//@ts-ignore
import { ViewStrokeRounded, Image03Icon, PencilEdit02Icon,Cancel01Icon,Attachment01Icon } from '@hugeicons-pro/core-stroke-rounded';
import TemplatePreview from '../TemplatePreview/TemplatePreview'; // Import your modal component
import type { TooltipProps } from '@mui/material/Tooltip';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { checkEventPermission } from "../../common/utility/utility";
import { useDropzone } from 'react-dropzone';
import TemplateCommentHistory from './TemplateCommentHistory';
import CustomTooltip from '../CustomTooltip/CustomTooltip';

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} placement="bottom" />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
  [`& .${tooltipClasses.arrow}`]: {
    display: 'none',
  },
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const ITEM_HEIGHT = 48;

interface TemplateListPropType {
  id: number;
  litmusId?: number;
  parentId?: number;
  createdBy?: number;
  clientId?: number;
  templateName: string;
  templateContent: string;
  subjectLine: string;
  fromName: string;
  fromEmail: string;
  preheader: string;
  resendSubjectLine: string;
  resendPreheader: string;
  status: number;
  statusName?: string;
  templateIdentifier?: string;
  templateVersion?:number;
  isTemplateInUse?:number;
}

interface ApiResponse {
  status: number;
  data: {
    data: TemplateListPropType[];
    result: number;
  };
}


const TemplateList: React.FC = () => {

  const [templateListData, setTemplateListData] = useState<TemplateListPropType[]>([])
  const [templateSearchData, setTemplateSearchData] = useState<TemplateListPropType[]>([])
  const [openAddTemplateModal, setOpenAddTemplateModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(true)
  const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false)
  const [templateInfoData, setTemplateInfoData] = useState<any>();
  const [showDeleteTemplateModal, setDeleteTemplateModal] = useState<boolean>(false);
  const [showDeactivateTemplateModal, setDeactivateTemplateModal] = useState<boolean>(false);
  const [showSubmitForApprovalModal, setSubmitForApprovalModal] = useState<boolean>(false);
  const [showCopyTemplateModal, setCopyTemplateModal] = useState<boolean>(false);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewContent, setPreviewContent] = useState('');
  const storedAppConfig = localStorage.getItem("appConfigs");
  const [submitmessage, setSubmitMessage] = useState('');
  const [validationError, setValidationError] = useState('');
  const [warningMessage, setWarningMessage] = useState<string>('');
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [openTemplateCommentHistoryModal, setOpenTemplateCommentHistoryModal] = useState(false);
  const [filteredData, setFilteredData] = useState<TemplateListPropType[]>([])
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [maxFileSizeDisplay, setMaxFileSizeDisplay] = useState<number>(0);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [anchorActionEl, setAnchorActionEl] = React.useState<any>({});
  const { user } = useSelector((state: RootState) => state.auth);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const userData = JSON.parse(localStorage.getItem("user"));

  const navigate = useNavigate()

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    getTemplateListData();
    const storedAppConfig = localStorage.getItem("appConfigs");
        if (storedAppConfig != null) {
          try {
            const parsedAppConfig = JSON.parse(storedAppConfig) as appConfigs[];
            const maxSize = parsedAppConfig.find((item) => item.configName === "TemplateMaxFileSize")?.configValue;
            const MaxFileSizeDisplay = maxSize != null ? Math.round(parseInt(maxSize) / 1024 / 1024) : 0;
            setMaxFileSizeDisplay(MaxFileSizeDisplay);
              } catch (error) {
        console.error("Error parsing appConfig data:", error);
      }
    }
  }, [user])

  const getTemplateListData = (): void => {
    setLoading(true)
    const ClientId = user?.clientId ?? 0;
    getAlltemplate(ClientId)
      .then(
        (res: ApiResponse) => {
          if (res.status === 200) {
            if (res.data.result === 1) {
              const templateArr: TemplateListPropType[] = [];
              res.data.data.map((template: any) => {
                template.Name = `${template.templateName}`
                templateArr.push(template)
              })
              setTemplateListData(templateArr)
              setTemplateSearchData(templateArr)
              setFilteredData(templateArr)
            } else {
              setTemplateListData([])
              setTemplateSearchData([])
              setFilteredData([])
            }

          }
        }
      )
      .catch(
        (error: any) => console.log("Error: ", error)
      )
      .finally(() => {
        setLoading(false)
      })
  }

  const handleAddTemplateClick = (): void => {
    navigate('/template/new-template')
  }

  const handleCloseAddTemplateModal = (): void => {
    setOpenAddTemplateModal(false)
  }

  const handleActionClick = (event: React.MouseEvent<HTMLElement>, id: number): void => {
    // anchorActionEl[id] = event.currentTarget
    setAnchorActionEl({ ...anchorActionEl, [id]: event.currentTarget });
  }

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.target.value.trim();
    let templateDataArr = [...filteredData]
    if (value !== "") {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-optional-chain
     templateDataArr = templateDataArr && templateDataArr.filter((template: TemplateListPropType) => {
      const trimmedValue = value.toLowerCase();
      const matchesName = template.templateName.toLowerCase().includes(trimmedValue);
      const matchesId = template.id.toString().includes(value);
      return matchesName || matchesId;
    })

    }
    setTemplateSearchData(templateDataArr)
  }

  const handleDeleteTemplate = (id: number, templateName: string): void => {
    setTemplateInfoData({ id, templateName });
    setDeleteTemplateModal(true)
    setAnchorActionEl(null);
    setAnchorActionEl({ ...anchorActionEl, [id]: null });
  }

  const handleDeleteTemplateClose = (): void => {
    setDeleteTemplateModal(false)
  }

  const handleDeleteTemplateConfirm = (): void => {
    setIsModalSaveLoading(true)

    const { id } = templateInfoData;

    const data = {
      "deletedBy": userData.id,
      "tempList": [
        {
          "templateId": id
        }
      ],
    }

    deletetemplate(data)
      .then(
        (res: ApiResponse) => {
          if (res.status === 200) {
            if (res.data.result === 1) {
              NotificationManager.success(DELETE_TEMPLATE_SUCCESS_MESSAGE, '', 5000);
              setDeleteTemplateModal(false)
              getTemplateListData()
            }
          }
        }
      )
      .catch((error: any) => console.log("Error", error))
      .finally(() => setIsModalSaveLoading(false))
  }

  const handleupdatestatus = (id: number, statusId: number, templateName: string, templateVersion?: number): void => {
    // Determine the new status based on the current `statusId`
    let newStatus: number | null = null;
    if (statusId === 1) {
      newStatus = 2; // If Approved, action is Reject
    } else if (statusId === 2) {
      newStatus = 1; // If Rejected, action is Approve
    }

    setTemplateInfoData({ id: id, newStatus: newStatus, templateName: templateName, templateVersion: templateVersion });

    // Trigger the modal and close any open action menus
    setDeactivateTemplateModal(true);
    setAnchorActionEl(null);
    setAnchorActionEl({ ...anchorActionEl, [id]: null });
  };

  const handleupdatestatusClose = (): void => {
    setValidationError('');
    setWarningMessage('');
    setSubmitMessage('');
    setSelectedFiles([]);
    setDeactivateTemplateModal(false)
    
  }

  const handleUpdateStatusConfirm = (): void => {
    if (!submitmessage.trim()) {
      if (templateInfoData?.newStatus === 1) {
        setShowConfirmModal(true);
        return;
      } else {
        setValidationError("Please provide a reason for rejection.");
        return;
      }
    }
    proceedWithSubmission();
  };

  const proceedWithSubmission = (): void => {
    setShowConfirmModal(false);
    setIsModalSaveLoading(true);

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const userData = JSON.parse(localStorage.getItem("user"))
    const { id, newStatus } = templateInfoData;

    const data = {
      "updatedBy": userData.id,
      "id": id,
      "status": (templateInfoData?.newStatus == 1) ? 1 : 2,
      "message": submitmessage ? submitmessage : null,
      "templateVersion": templateInfoData?.templateVersion
    }

    // Create FormData object
      const formData = new FormData();

      selectedFiles.forEach((file) => {
        formData.append('templateCommentFiles', file);
      });

    updatestatus(data, formData)
      .then((res: ApiResponse) => {
        if (res.status === 200 && res.data.result === 1) {
          NotificationManager.success(newStatus === 1 ? ACTIVATE_TEMPLATE_SUCCESS_MESSAGE : DEACTIVATE_TEMPLATE_SUCCESS_MESSAGE, "", 5000);
          setDeactivateTemplateModal(false);
          setSubmitMessage("");
          setSelectedFiles([]);
          getTemplateListData();
        }
      })
      .catch((error) => {
        console.log("Error", error)
        NotificationManager.error("Invalid file format or size. Allowed extensions: .jpg, .jpeg, .png, .doc, .docx, .txt, .odt, .pdf", '', 5000);
      })
      .finally(() => setIsModalSaveLoading(false));
  };

  const handleSubmitForApproval = (id: number, templateName: string): void => {
    setTemplateInfoData({ id: id, newStatus: 1, templateName: templateName });

    // Trigger the modal and close any open action menus
    setSubmitForApprovalModal(true);
    setAnchorActionEl(null);
    setAnchorActionEl({ ...anchorActionEl, [id]: null });
  };

  const handleSubmitForApprovalClose = (): void => {
    setSubmitForApprovalModal(false)
    setValidationError('');
    setWarningMessage('');
    setSubmitMessage('');
  }

  const handleSubmitForApprovalConfirm = (): void => {
    setIsModalSaveLoading(true)

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const userData = JSON.parse(localStorage.getItem("user"))
    const { id } = templateInfoData;

    submitapproval(id, userData.id)
      .then(
        (res: ApiResponse) => {
          if (res.status === 200) {
            if (res.data.result === 1) {
              NotificationManager.success("Template sent for approval", '', 5000);
              setSubmitForApprovalModal(false)
              getTemplateListData()
            }
          }
        }
      )
      .catch((error: any) => console.log("Error", error))
      .finally(() => setIsModalSaveLoading(false))
  }

  const handleCopyTemplate = (id: number, templateName: string): void => {
    setTemplateInfoData({ id, templateName });
    setCopyTemplateModal(true)
    setAnchorActionEl(null);
    setAnchorActionEl({ ...anchorActionEl, [id]: null });
  }

  const handleCopyTemplateClose = (): void => {
    setCopyTemplateModal(false)
  }

  const handleCopyTemplateConfirm = (): void => {
    setIsModalSaveLoading(true)

    const { id } = templateInfoData;

    copytemplate(id, userData.id)
      .then(
        (res: ApiResponse) => {
          if (res.status === 200) {
            if (res.data.result === 1) {
              NotificationManager.success(COPY_TEMPLATE_SUCCESS_MESSAGE, '', 5000);
              setCopyTemplateModal(false)
              getTemplateListData()
            }
          }
        }
      )
      .catch((error: any) => console.log("Error", error))
      .finally(() => setIsModalSaveLoading(false))
  }

  const handleTemplateValue = (newValue: { value: string; label: string } | null): void => {
    if (newValue) {
     

      // Filter data based on the selected value
      let filteredTemplateData = [...templateListData];
      if (newValue.value !== '10') {
        filteredTemplateData = filteredTemplateData.filter(
          (item) => String(item.status) === newValue.value // Ensure both are strings for comparison
        );
      }
      setFilteredData(filteredTemplateData);
      setTemplateSearchData(filteredTemplateData); // Update state with filtered data
    } else {
      setFilteredData([...templateListData]);
      setTemplateSearchData([...templateListData]); // Reset to full list
    }
  };
  const handleEditNavigation = (id: number): void => {
    navigate(`/template/edit-template/edit/${id}`);
  }

  const handleViewTemplateHistory = (id: number, templateName: string): void => {
    setTemplateInfoData({ id, templateName });
    setOpenTemplateCommentHistoryModal(true);
  }
  // Dropdown options
  const options = [
    // { value: '10', label: 'All' },          // Use '10' as the identifier for all data
    { value: '1', label: 'Approved' },
    { value: '2', label: 'Rejected' },
    { value: '3', label: 'In Progress' },
    { value: '4', label: 'Pending' },
  ];

  const columns: TableColumn<TemplateListPropType>[] = [
    {
      name: 'Preview',
      center: true,
      cell: (row: TemplateListPropType) => {
        let imageUrl: string | null = null;

        if (storedAppConfig != null) {
          try {
            const parsedAppConfig = JSON.parse(storedAppConfig) as appConfigs[];
            const templateVersion = row.templateVersion ?? 1;
            const TemplateImagePublicURL = parsedAppConfig.find(
              (item) => item.configName === "TemplateImagePublicURL"
            )?.configValue;
            if (TemplateImagePublicURL != '') {
              imageUrl = `${TemplateImagePublicURL}Template/${row.templateIdentifier}/${templateVersion}/Template_Short.png`;
            }
          } catch (error) {
            console.error("Error parsing appConfig data:", error);
          }
        }

        return (
          <div className="relative w-[90px] h-[90px] flex items-center justify-center" onClick={(row.templateContent !== "") ? () => {
            setPreviewContent(row.templateContent);
            setIsPreviewModalOpen(true);
          } : undefined}>
            {(imageUrl != null) ? (
              <img
                src={imageUrl}
                width={90}
                height={90}
                alt="Preview"
                className="icon-hover"
                onError={(e) => {
                  e.currentTarget.style.display = 'none'; // Hide broken image
                  const iconElement = e.currentTarget.nextElementSibling as HTMLElement;
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  if (iconElement) iconElement.style.display = 'flex'; // Show icon
                }}
                style={{ borderRadius: '8px', objectFit: 'cover' }}
              />
            ) : null}
            <HugeiconsIcon
              icon={Image03Icon}
              size={24}
              color="#3a3a3a"
              className="hidden" // Initially hidden, shown if image fails
            />
            <div
              className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 rounded-lg hover:opacity-100 transition-opacity cursor-pointer"
            >
              <HugeiconsIcon
                icon={ViewStrokeRounded}
                size={24}
                color="white"
                strokeWidth={0.5}
                className={`cursor-pointer ${(row.templateContent === "") ? 'opacity-50 cursor-not-allowed' : ''}`}
              />
            </div>
          </div>
        );
      },
      width: '10%',
      sortable: false,
    },
    {
      name: 'Template',
      selector: (row: TemplateListPropType) => row.templateName,
      cell: (row: any) => {
        return (
          <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
            <div className="overflow-hidden" style={{ width: '100%' }}>
               <CustomTooltip title={row.templateName} placement="bottom">
              <p
                className="text-14 font-semibold underline leading-[22px] cursor-pointer text-muted"
                onClick={() => handleEditNavigation(row.id)}
                 style={{
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                title="Click to edit"
              >
                {row.templateName}
              </p>
              </CustomTooltip>
              <p className="text-14 text-muted">
                <span className='font-semibold'>ID:</span> {row.id}
              </p>
            </div>
          </div>
        );
      },
      width: '14%',
      sortable: true
    },
    {
      name: 'From Name',
      selector: (row: TemplateListPropType) => row.fromName,
      width: '14%',
      sortable: true
    },
    {
      name: 'From Email Name',
      selector: (row: TemplateListPropType) => row.fromEmail,
      width: '14%',
       cell: (row: TemplateListPropType) => {
        return (
        
            <BootstrapTooltip title={row.fromEmail} >
             <p className="text-14 text-muted truncate">
                {row.fromEmail}
              </p>
            </BootstrapTooltip>
         
        );
      },
      sortable: true
    },
    {
      name: 'Subject',
      selector: (row: TemplateListPropType) => row.subjectLine,
      width: '20%',
       cell: (row: TemplateListPropType) => {
        return (
        
            <BootstrapTooltip title={row.subjectLine} >
             <p className="text-14 text-muted truncate">
                {row.subjectLine}
              </p>
            </BootstrapTooltip>
         
        );
      },
      sortable: true
    },

    {
      name: 'Status',
      sortable: false,
      width: "15%",
      center: true,
      cell: (row: TemplateListPropType) => {
        if (row.status == 4) {
          return (
            <div className="badge truncate" style={{ background: '#D9DBF9', padding: '10px 15px', color: '#191975', border: '0px', }}>Pending approval</div>
          );
        }
        if (row.status == 3) {
          return (
            <div className="badge truncate" style={{ background: '#FFF2C2', padding: '10px 15px', color: '#FF7A00', border: '0px', }}>In progress</div>
          );
        }
        if (row.status == 2) {
          return (
            <div className="badge truncate" style={{ background: '#FFF5F6', padding: '10px 15px', color: '#F13139', border: '0px', }}>Rejected</div>
          );
        }
        if (row.status == 1) {
          return (
            <div className="badge truncate" style={{ background: '#CCFFEA', padding: '10px 15px', color: '#06A864', border: '0px', }}>Approved</div>
          );
        }
        return <div></div>;
      },
    },
    {
      name: 'Actions',
      cell: (row: TemplateListPropType) => {
        return (
          <div className='flex items-center'>
             {
              row.status !== 3 && (
                <div className="icon-hover-container" id="comment-icon">
                  <HugeiconsIcon
                    icon={Comment02Icon }
                    size={20}
                    color="#3A3A3A"
                    strokeWidth={0.2}
                    onClick={() => handleViewTemplateHistory(row.id, row.templateName)}
                  />
                </div>
              )
            }
            <div className="icon-hover-container" id="edit-icon">
              <Link
                to={{ pathname: `/template/edit-template/edit/${row.id}` }}
                state={{ clientData: row }}
                style={{ width: "20px" }}
              >
                <HugeiconsIcon
                  icon={PencilEdit02Icon}
                  size={20}
                  color="#3A3A3A"
                  strokeWidth={0.2}
                />
              </Link>
            </div>
           
            <div className='flex'>
              {(checkEventPermission('TEMPLATE_APPROVE') ||
                (checkEventPermission('TEMPLATE_SUB_APPROVE') && row.status === 3) ||
                checkEventPermission('TEMPLATE_DUPLICATE') || checkEventPermission('TEMPLATE_DELETE')) && (
                  <>
                    <IconButton
                      aria-label="more"
                      id="long-button"
                      // aria-controls={open ? 'long-menu' : undefined}
                      // aria-expanded={open ? 'true' : undefined}
                      aria-haspopup="true"
                      onClick={(e) => handleActionClick(e, row.id)}
                    >

                      <HugeiconsIcon
                        icon={MoreVerticalSolidRounded}
                        size={20}
                        color="#3A3A3A"
                        strokeWidth={0.2}
                      />

                    </IconButton>
                    <Menu
                      id={`${row.id}`}
                      className='table-action-menu'
                      MenuListProps={{
                        'aria-labelledby': 'long-button',
                      }}
                      anchorEl={anchorActionEl[row.id]}
                      open={Boolean(anchorActionEl[row.id])}
                      onClose={() => setAnchorActionEl({ ...anchorActionEl, [row.id]: null })}
                  slotProps={{ paper: {
                        style: {
                          maxHeight: ITEM_HEIGHT * 4.5,
                          width: '20ch',
                          // maxWidth: 'fit-content'
                        },
                      }}}
                    >
                      {/* If RoleId is 1, show Approve/Reject options */}
                      {checkEventPermission('TEMPLATE_APPROVE') && (
                        <>
                          {row.status == 1 && (
                            <BootstrapTooltip title={row.isTemplateInUse === 1 ? TEMPLATE_IN_USE_MESSAGE : ""} arrow disableHoverListener={row.isTemplateInUse !== 1}>
                              <span>
                                <MenuItem onClick={() => handleupdatestatus(row.id, row.status, row.templateName, row.templateVersion)} disabled={row.isTemplateInUse === 1}>
                                  <span  className="text-muted font-normal">Reject</span>
                                </MenuItem>
                              </span>
                          </BootstrapTooltip>
                          )}

                          {row.status == 2 && (
                            <MenuItem onClick={() => handleupdatestatus(row.id, row.status, row.templateName, row.templateVersion)}>
                              <span  className="text-muted font-normal">Approve</span>
                            </MenuItem>
                          )}

                          {row.status === 4 && (
                            <>
                              <MenuItem onClick={() => handleupdatestatus(row.id, 2, row.templateName, row.templateVersion)}>
                                <span  className="text-muted font-normal">Approve</span>
                              </MenuItem>
                              <MenuItem onClick={() => handleupdatestatus(row.id, 1, row.templateName, row.templateVersion)}>
                                <span  className="text-muted font-normal">Reject</span>
                              </MenuItem>
                            </>
                          )}
                        </>
                      )}
                      {/* If status is in in progress , show "Submit for Approval" option */}
                      {checkEventPermission('TEMPLATE_SUB_APPROVE') && row.status == 3 && (
                        <MenuItem onClick={() => handleSubmitForApproval(row.id, row.templateName)}>
                          <span  className="text-muted font-normal">Submit for Approval</span>
                        </MenuItem>
                      )}
                      {checkEventPermission('TEMPLATE_DUPLICATE') &&
                        <MenuItem onClick={() => handleCopyTemplate(row.id, row.templateName)}>
                          <span  className='text-muted font-normal'>Duplicate</span>
                        </MenuItem>
                      }
                      {checkEventPermission('TEMPLATE_DELETE') &&
                        <BootstrapTooltip title={row.statusName === 'Approved' ? TEMPLATE_DELETE_INVALID : ""} arrow disableHoverListener={row.statusName !== 'Approved'}>
                          <span>
                            <MenuItem onClick={() => handleDeleteTemplate(row.id, row.templateName)} disabled={row.statusName === 'Approved'}>
                              <span style={{ cursor: row.statusName !== 'Approved' ? 'pointer' : 'not-allowed', color: row.statusName === 'Approved' ? '#A0A0A0' : '#F13139' }}>Delete</span>
                            </MenuItem>
                          </span>
                        </BootstrapTooltip>
                      }
                    </Menu>
                  </>
                )
              }
            </div>

          </div>
        )
      },
      // width: '8%',
      style: {justifyContent: 'center', marginLeft: '35px'},
      sortable: false
    },

  ]
 

  const onDrop = (acceptedFiles: File[]): void => {
  if (acceptedFiles.length === 0) return;
  const maxFiles = 10;
  const allowedExtensions = [
    '.jpg', '.jpeg', '.png', 
    '.doc', '.docx', '.txt', '.odt', 
    '.pdf'
  ];

  const invalidExtensionFiles: string[] = [];
  const validExtensionFiles: File[] = [];

  // 1️⃣ Separate valid and invalid extension files
  acceptedFiles.forEach((file) => {
    const lowerName = file.name.toLowerCase();
    const isValid = allowedExtensions.some(ext => lowerName.endsWith(ext));

    if (isValid) {
      validExtensionFiles.push(file);
    } else {
      invalidExtensionFiles.push(file.name);
    }
  });

  // 2️⃣ Show error for invalid extension files
  if (invalidExtensionFiles.length > 0) {
    NotificationManager.error('Please select valid file');
  }

  // 3️⃣ Remove duplicates
  const uniqueValidFiles = validExtensionFiles.filter(
    f => !selectedFiles.some(existing => existing.name === f.name)
  );



  // 4️⃣ Respect 10-file limit
  const availableSlots = maxFiles - selectedFiles.length;
  const filesToAdd = uniqueValidFiles.slice(0, availableSlots);
  const exceedingFiles = uniqueValidFiles.slice(availableSlots);

  if (exceedingFiles.length > 0) {
    NotificationManager.error(
      `Max of 10 files is allowed.`,
      '',
      5000
    );
  }

  // 5️⃣ Add valid files
  if (filesToAdd.length > 0) {
    setSelectedFiles(prev => [...prev, ...filesToAdd]);
    NotificationManager.success(
      `${filesToAdd.length} file(s) added successfully`,
      '',
      3000
    );
  }
};


  const { getRootProps, getInputProps, isDragActive } = useDropzone({
      onDrop,
       accept: { '*/*': [] },
    });
console.log("selectedFiles", selectedFiles);

const selectedFilesColumns = [
  {
    name: "Image",
    selector: (row: any) => row.name,
    cell: (row: any) => {
      const isImage = row.type?.startsWith('image/') || /\.(jpg|jpeg|png)$/i.test(row.name);
      
      return (
        <div>
          <BootstrapTooltip title={row.name}>
           
              {isImage ? (
                // Show image thumbnail
                <>
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      zIndex: 1,
                    }}
                  />
                  <img
                    src={URL.createObjectURL(row)}
                    alt="preview"
                    className="h-10 object-cover rounded-md"
                    style={{
                      opacity: row.uploading ? 0.5 : 1,
                    }}
                  />
                </>
              ) : (
                // Show attachment icon for non-image files
              
                  <HugeiconsIcon
                    icon={Attachment01Icon}
                    size={24}
                    strokeWidth={0.2}
                    color="#3a3a3a"
                  />
               
              )}
            
          </BootstrapTooltip>
        </div>
      );
    },
    width: "15%",
  },
  {
    name: "Name",
    selector: (row: any) => row.name,
    cell: (row: any) => {
      return (
        <div className="flex items-center">
          {row.path ? (
            <a
              href={row.path}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 hover:underline truncate block max-w-[300px] text-[#3A3A3A]"
            >
              {row.name}
            </a>
          ) : (
            <span className="truncate block max-w-[300px] text-[#3A3A3A]">
              {row.name}
            </span>
          )}
          <div className="icon-hover-container"></div>
        </div>
      );
    },
    wrap: true,
    width: "45%",
  },
  {
    name: "Size",
    selector: (row: any) => row.size,
    cell: (row: any) => {
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      const formatFileSize = (bytes: number) => {
        if (!bytes || bytes === 0) return '';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
      };
      
      return (
        <span className="text-[#3A3A3A]">
          {typeof row.size === 'number' ? formatFileSize(row.size) : row.size || ''}
        </span>
      );
    },
     center: true,
    width: "20%",
  },
  {
    name: "Actions",
    cell: (row: any) => {
      return (
        <div className="flex items-center">
          <div className='flex'>
          <IconButton
            onClick={() => setSelectedFiles(selectedFiles.filter(f => f.name !== row.name))}           
          >
            <HugeiconsIcon
              icon={Cancel01Icon}
              size={20}
              strokeWidth={0.2}
            />
          </IconButton>
          </div>
        </div>
      );
    },
    width: "20%",
    center: true,
  }
];
  return (
    <>
      <h2 className="text-2xl font-semibold text-title">Template Overview</h2>
      <div className="mt-[20px] mb-[20px] live-outreach-container">
        <Grid container spacing={2} alignItems={'center'}  wrap="wrap">
          <Grid item xs={12} md={4}>
            <div className="flex flex-col basis-3/5">
              <input type="text" placeholder="Search by template name or id" className="input input-bordered search-input-white focus:ring-0 focus:outline-none border-[#E6ECF2] font-normal text-14 text-muted w-full" onChange={handleSearch} />
            </div>
          </Grid>
          <Grid  item xs={12} md={4} >
            <FormControl fullWidth>
              <Autocomplete
                options={options}
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                getOptionLabel={(option) => option.label}
                popupIcon={
                  <HugeiconsIcon
                    icon={ArrowDown01Icon}
                    size={18}
                    color="#3A3A3A"
                    strokeWidth={0.2}

                  />
                }
                onChange={(event, newValue) => handleTemplateValue(newValue)}
                // disableClearable
                // isOptionEqualToValue={(option, value) => option.value === value?.value}
                renderInput={(params) => (
                  <TextField
                    label="Status"
                    {...params}
                    placeholder="Select Status"
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '40px',
                        height: '40px',
                        width: '200px', // Increased width
                      },
                    }}
                  />
                )}
                sx={{
                  '& .MuiAutocomplete-clearIndicator': {
                    marginRight: '-12px'
                  },
                  '& .MuiAutocomplete-input': {
                    width: '70%'
                  }
                }}
              //disableClearable
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4} className="flex justify-end">
            {checkEventPermission("TEMPLATE_ADD") &&
              <GradientButton color='red' onClick={handleAddTemplateClick}>
                <span style={{
                  width: "20px",
                  height: "20px",
                  background: "#fff",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50px",
                  marginRight: "5px"
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 19 19" fill="none">
                    <path d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z" fill="#F13139" />
                    <path d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z" fill="#F13139" />
                  </svg>
                </span>
                Add New Template
              </GradientButton>
            }
          </Grid>
        </Grid>
      </div>
      {/* <div className="flex my-3 gap-x-2 justify-between items-center">
        <div className="basis-3/5">
          <div className="flex flex-row justify-between items-center gap-x-4 my-2">
            <div className="flex flex-col basis-3/5">
              <input type="text" placeholder="Search template" className="input input-bordered search-input-white focus:ring-0 focus:outline-none border-[#E6ECF2] font-normal text-14 text-muted w-full" onChange={handleSearch} />
            </div>
            <div className="flex flex-col basis-2/5">
              <FormControl fullWidth>
                <Autocomplete
                  options={options}
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                  getOptionLabel={(option) => option.label}
                  popupIcon={
                    <HugeiconsIcon
                      icon={ArrowDown01Icon}
                      size={18}
                      color="#3A3A3A"
                      strokeWidth={0.2}

                    />
                  }                 
                  onChange={(event, newValue) => handleTemplateValue(newValue)}
                  // disableClearable
                  // isOptionEqualToValue={(option, value) => option.value === value?.value}
                  renderInput={(params) => (
                    <TextField
                    label="Status"
                      {...params}
                      placeholder="Select Status"
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '40px',
                          height: '40px',
                          width: '200px', // Increased width
                        },
                      }}
                    />
                  )}
                  sx={{
                    '& .MuiAutocomplete-clearIndicator': {
                      marginRight: '-12px'
                    },
                    '& .MuiAutocomplete-input': {
                      width: '70%'
                    }
                  }}
                //disableClearable
                />
              </FormControl>
            </div>
          </div>
        </div>
        <div className="basis-2/5 justify-end flex">
          {checkEventPermission("TEMPLATE_ADD") &&
            <GradientButton color='red' onClick={handleAddTemplateClick}>
              <span style={{
                width: "20px",
                height: "20px",
                background: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50px",
                marginRight: "5px"
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 19 19" fill="none">
                  <path d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z" fill="#F13139" />
                  <path d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z" fill="#F13139" />
                </svg>
              </span>
              Add New Template
            </GradientButton>
          }
        </div>
      </div> */}
      <div className='data-table-container campaign-table mb-10 template-table-container'>
        <CustomDataTable
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          columns={columns}
          data={templateSearchData}
          pagination
          // selectableRows
          progressPending={loading}
        />

        <MUIModal title='Add New Template' openModal={openAddTemplateModal} closeModal={handleCloseAddTemplateModal} width={'50%'} >
          <AddTemplateForm />
        </MUIModal>

        <MUIModal title='Comments' openModal={openTemplateCommentHistoryModal} closeModal={() => setOpenTemplateCommentHistoryModal(false)} width={'50%'} >
          <TemplateCommentHistory templateId={templateInfoData?.id} templateName={templateInfoData?.templateName} />
        </MUIModal>


        <BootstrapDialog
          onClose={handleDeleteTemplateClose}
          aria-labelledby="customized-dialog-title"
          open={showDeleteTemplateModal}
          PaperProps={{
            sx: {
              width: '550px',
              height: '200px'
            },
          }}
        >
          <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
            Delete Template
          </DialogTitle>

          <IconButton
            aria-label="close"
            onClick={handleDeleteTemplateClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <HugeiconsIcon
              icon={MultiplicationSignStrokeStandard}
              size={24}
              color="currentcolor"
              strokeWidth={0.5}
            />

          </IconButton>
          <DialogContent>
            <p className='text-14 text-muted'>{ARE_YOU_SURE} {DELETE_TEMPLATE} <span className='font-semibold'>{templateInfoData?.templateName}</span>?</p>
          </DialogContent>
          <DialogActions sx={{ background: '#F9F9F9' }}>

            <OutlineButton color='gray' onClick={handleDeleteTemplateClose} width='100px'>Cancel</OutlineButton>

            <GradientButton type='button' color='red' onClick={handleDeleteTemplateConfirm} width='100px'>{!isModalSaveLoading ? 'Delete' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
          </DialogActions>
        </BootstrapDialog>

        <BootstrapDialog onClose={handleCopyTemplateClose} aria-labelledby="customized-dialog-title" open={showCopyTemplateModal} PaperProps={{ sx: { width: '550px', height: '200px' }, }}>
          <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
            Duplicate Template
          </DialogTitle>
          <IconButton aria-label="close" onClick={handleCopyTemplateClose} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}>
            <HugeiconsIcon
              icon={MultiplicationSignStrokeStandard}
              size={24}
              color="currentcolor"
              strokeWidth={0.5}
            />

          </IconButton>
          <DialogContent>
            <p className='text-14 text-muted'>{ARE_YOU_SURE} {COPY_TEMPLATE} <span className='font-semibold'>{templateInfoData?.templateName}</span>?</p>
          </DialogContent>
          <DialogActions sx={{ background: '#F9F9F9' }}>
            <OutlineButton color='gray' onClick={handleCopyTemplateClose} width='100px'>Cancel</OutlineButton>
            <GradientButton type='button' color='red' onClick={handleCopyTemplateConfirm} width='100px'>{!isModalSaveLoading ? 'Duplicate' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
          </DialogActions>
        </BootstrapDialog>

        <MUIModal title={templateInfoData?.newStatus == 1 ? "Approve Template" : "Reject Template"} openModal={showDeactivateTemplateModal} closeModal={handleupdatestatusClose} width={'50%'}>
            <React.Fragment>
            <div className="relative px-[16px] pt-[10px] pb-[50px]">
              <p className='text-14 text-muted'>{ARE_YOU_SURE}{" "}{templateInfoData?.newStatus == 1 ? "approve the template" : "reject the template"}{" "}<span className='font-semibold'>{templateInfoData?.templateName}</span>?</p>

              {/* Textarea instead of TextField */}
              <TextareaAutosize
                minRows={3}
                placeholder="Enter your comment"
                value={submitmessage}
                onChange={(e) => {
                  setSubmitMessage(e.target.value);
                  setValidationError(''); // Clear error on input
                  setWarningMessage('');
                }}
                className="w-full border rounded-md p-2 mt-2"
                style={{
                  borderColor: validationError ? 'red' : '#ccc',
                  fontSize: '14px',
                  width: '100%',
                }}
              />

              {/* Validation Message with More Space */}
              {validationError.length > 0 && (
                <div className="flex text-primary ml-1 mt-2 text-md font-normal">
                  <img src="/assets/images/attention.svg" alt="Error" width={12} height={12} className="mr-1" />
                  {validationError}
                </div>
              )}

              {/* Warning Message (Yellow) */}
              {warningMessage && (
                <div className="flex text-primary ml-1 mt-2 text-md font-normal">
                  <img src="/assets/images/attention.svg" alt="Warning" width={12} height={12} className="mr-1" />
                  {warningMessage}
                </div>
              )}

              <div className='mt-[20px] mb-[30px]'>
                  <div {...getRootProps({ className: 'dropzone' })}>
                    <input {...getInputProps()} />
                    {isDragActive ? (
                      <p>Drop the files here ...</p>
                    ) : (
                      <>
                        <p>
                          <strong className='font-semibold'>Drag and drop or</strong>
                          <span
                            style={{
                              color: '#007bff',
                              cursor: 'pointer',
                              fontWeight: '600',
                            }}
                          >
                            {' '}
                            Click here{' '}
                          </span>
                          <strong className='font-semibold'>to choose file.</strong>
                        </p>
                       <span
                                    style={{
                                      display: 'block',
                                      marginTop: '15px',
                                      fontSize: '12px',
                                      color: '#555'
                                    }}
                                  >
                                     { `Max size: ${maxFileSizeDisplay} MB. `}{' '} 
                                    File format: {'.jpg, .jpeg, .png, .doc, .docx, .txt, .odt, .pdf'}
                                  </span>

                      </>
                    )}
                  </div>

              </div>

              {
                selectedFiles.length > 0 && (
                     <div className="mb-[30px]">
                                
                                <div className="flex justify-between items-center mb-2 ">
                        <h3 className="text-lg font-semibold text-[#3A3A3A]">Selected Files</h3>
                      </div>
                       <div className="border rounded-lg bg-white p-2" style={{ borderColor: '#E6ECF2' }}>
                              <CustomDataTable
                                columns={selectedFilesColumns}
                                data = {selectedFiles} 
                                selectableRows={false}
                              />
                             </div>
                              </div>
                  // <div>
                  //   <div className="text-muted text-14 mb-2">
                  //     <span className="font-semibold">Selected Files:</span>
                  //   </div>
                  //   {
                  //     selectedFiles.map((file) => (
                  //       <div key={file.name} className="flex items-center justify-between mb-[10px] p-[5px] border-0">
                  //         <span className="font-semibold">
                  //           {file.name}
                  //         </span>
                  //         <a
                  //           href="javascript:void(0)"
                  //           onClick={() => setSelectedFiles(selectedFiles.filter(f => f.name !== file.name))}
                  //           style={{ color: 'red', paddingTop: '10px' }}
                  //         >
                  //           Remove
                  //         </a>
                  //       </div>
                  //     ))
                  //   }
                  // </div>
                )
              }
              
            </div>
            <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
              <div className="w-full relative col-span-3">
                <button
                  type="button"
                  className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted"
                  onClick={handleupdatestatusClose}
                >
                  {LABEL_BTN_CANCEL}
                </button>
              </div>
              <div className="w-full relative col-span-3">
                <button
                  type="button"
                  onClick={handleUpdateStatusConfirm}
                  className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]"
                >
                  {!isModalSaveLoading ? (templateInfoData?.newStatus == 1 ? "Approve" : "Reject") : (<span className="loading loading-spinner loading-xs text-white"></span>)}
                </button>
              </div>
            </div>
            </React.Fragment>
        </MUIModal>

        

        {/* Confirmation Modal */}
        <BootstrapDialog
            onClose={() => setShowConfirmModal(false)}
            open={showConfirmModal}
            PaperProps={{
              sx: { width: "400px", height: "180px" },
            }}
          >

            <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
              Confirm Approval
            </DialogTitle>
            <DialogContent>
              <p className="text-14 text-muted">Are you sure you want to approve without any comment?</p>
            </DialogContent>
            <DialogActions sx={{ background: "#F9F9F9" }}>
              <OutlineButton color="gray" onClick={() => setShowConfirmModal(false)} width="130px">No</OutlineButton>
              <GradientButton type="button" color="red" onClick={proceedWithSubmission} width="130px">Yes</GradientButton>
            </DialogActions>
          </BootstrapDialog>

        <BootstrapDialog onClose={handleSubmitForApprovalClose} aria-labelledby="customized-dialog-title" open={showSubmitForApprovalModal} PaperProps={{ sx: { width: '550px', height: '200px' }, }}>
          <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
            Submit for Approval
          </DialogTitle>
          <IconButton aria-label="close" onClick={handleSubmitForApprovalClose} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}>
            <HugeiconsIcon
              icon={MultiplicationSignStrokeStandard}
              size={24}
              color="currentcolor"
              strokeWidth={0.5}
            />
          </IconButton>
          <DialogContent>
            <p className='text-14 text-muted'>{ARE_YOU_SURE}{" "}{"submit "}<span className='font-semibold'>{templateInfoData?.templateName}</span>{" for approval?"}</p>
          </DialogContent>
          <DialogActions sx={{ background: '#F9F9F9' }}>
            <OutlineButton color='gray' onClick={handleSubmitForApprovalClose} width='130px'>No</OutlineButton>
            <GradientButton type='button' color='red' onClick={handleSubmitForApprovalConfirm} width='130px'>{!isModalSaveLoading ? 'Yes' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
          </DialogActions>
        </BootstrapDialog>
        <TemplatePreview
          isOpen={isPreviewModalOpen}
          onClose={() => setIsPreviewModalOpen(false)}
          content={previewContent}
        />
      </div>
    </>
  );
};


export default TemplateList;
